import React from 'react';
import { buttonClass } from '../../uiTokens';

/**
 * Design-system button. Renders a <button> by default; pass `as="a"` with
 * `href` for link-styled actions.
 */
export default function Button({
  as: Tag = 'button',
  variant = 'primary',
  size = 'md',
  block = false,
  className = '',
  children,
  ...rest
}) {
  const props = Tag === 'button' && !rest.type ? { type: 'button', ...rest } : rest;
  return (
    <Tag className={`${buttonClass({ variant, size, block })} ${className}`.trim()} {...props}>
      {children}
    </Tag>
  );
}
